
import { computed, defineComponent, ref } from "vue";
import { mapActions, mapState } from "vuex";
import CKEditorVue from "@/components/CKEditor.vue";
import state from "@/store/state";

export default defineComponent({
  setup() {
    const message = ref("");
    const floatingStateMessage = computed(() => message.value.length >= 5);
    const floatingInvalidFeedbackMessage = computed(() =>
      message.value.length > 0 ? "Ingrese al menos 5 caracteres" : "Por favor ingrese algo"
    );

    return {
      message,
      floatingStateMessage,
      floatingInvalidFeedbackMessage,
    };
  },

  name: "GroupInputMessage",
  components: { CKEditorVue },
  methods: {
    ...mapActions(["updateGroup"]),
    ...mapState(["currentGroup"]),
    async handleAddMessage() {
      const groupToUpdate = {
        groupname: state.currentGroup.groupname,
        members: state.currentGroup.members,
        messages: [...state.currentGroup.messages, { message: this.message, time: new Date() }],
        id: state.currentGroup.id,
      };
      if (this.message !== "") {
        await this.updateGroup(groupToUpdate);
      }
      this.message = "";
    },
  },
  data() {
    return {
      editorData: "",
    };
  },
});
